import { AddToDocumentHead } from "../DocumentHead"
import { Theme } from "../theme/theme.types"

interface Props {
  theme: Theme
}

export const CSSProperties = ({ theme }: Props) => (
  <AddToDocumentHead>
    <style type="text/css">
      {`:root{
          --mdc-typography-font-family: ${theme.typography.body.fontFamily};
          --mdc-typography-body1-font-family: ${theme.typography.body.fontFamily};
          --mdc-typography-body1-font-size: ${theme.typography.body.fontSize};
          --mdc-typography-body1-font-weight: ${theme.typography.body.fontWeight};
          --mdc-typography-body1-line-height: ${theme.typography.body.lineHeight};
          ${
            theme.typography.body.letterSpacing
              ? `--mdc-typography-body1-letter-spacing: ${theme.typography.body.letterSpacing};`
              : ``
          }
          --mdc-typography-body2-font-family: ${theme.typography.body2.fontFamily};
          --mdc-typography-body2-font-size: ${theme.typography.body2.fontSize};
          --mdc-typography-body2-font-weight: ${theme.typography.body2.fontWeight};
          --mdc-typography-body1-line-height: ${theme.typography.body2.lineHeight};
          ${
            theme.typography.body2.letterSpacing
              ? `--mdc-typography-body2-letter-spacing: ${theme.typography.body2.letterSpacing};`
              : ``
          }          
          --mdc-typography-headline1-font-family: ${theme.typography.headline1.fontFamily};
          --mdc-typography-headline1-font-size: ${theme.typography.headline1.fontSize};
          --mdc-typography-headline1-font-weight: ${theme.typography.headline1.fontWeight};
          ${
            theme.typography.headline1.lineHeight
              ? `--mdc-typography-headline1-line-height: ${theme.typography.headline1.lineHeight};`
              : ``
          }
          ${
            theme.typography.headline1.letterSpacing
              ? `--mdc-typography-headline1-letter-spacing: ${theme.typography.headline1.letterSpacing};`
              : ``
          }
          --mdc-typography-headline2-font-family: ${theme.typography.headline2.fontFamily};
          --mdc-typography-headline2-font-size: ${theme.typography.headline2.fontSize};
          --mdc-typography-headline2-font-weight: ${theme.typography.headline2.fontWeight};
          ${
            theme.typography.headline2.lineHeight
              ? `--mdc-typography-headline2-line-height: ${theme.typography.headline2.lineHeight};`
              : ``
          }
          ${
            theme.typography.headline2.letterSpacing
              ? `--mdc-typography-headline2-letter-spacing: ${theme.typography.headline2.letterSpacing};`
              : ``
          }
          --mdc-typography-headline3-font-family: ${theme.typography.headline3.fontFamily};
          --mdc-typography-headline3-font-size: ${theme.typography.headline3.fontSize};
          --mdc-typography-headline3-font-weight: ${theme.typography.headline3.fontWeight};
          ${
            theme.typography.headline3.lineHeight
              ? `--mdc-typography-headline3-line-height: ${theme.typography.headline3.lineHeight};`
              : ``
          }
          ${
            theme.typography.headline3.letterSpacing
              ? `--mdc-typography-headline3-letter-spacing: ${theme.typography.headline3.letterSpacing};`
              : ``
          }
          --mdc-layout-grid-margin-desktop: ${theme.grid.desktop.margin};
          --mdc-layout-grid-gutter-desktop: ${theme.grid.desktop.gutter};
          --mdc-layout-grid-margin-tablet: ${theme.grid.tablet.margin};
          --mdc-layout-grid-gutter-tablet: ${theme.grid.tablet.gutter};
          --mdc-layout-grid-margin-mobile: ${theme.grid.mobile.margin};
          --mdc-layout-grid-gutter-mobile: ${theme.grid.mobile.gutter};
          --mdc-theme-surface: ${theme.surface.color};
          --mdc-theme-on-surface: ${theme.surface.background};
        }`}
    </style>
  </AddToDocumentHead>
)
